import React from 'react';
import NotificationCard from './notificationCard';

function NotificationBar() {
  return (
    <div >
      <NotificationCard />
    </div>
  );
}

export default NotificationBar;